import StatisticCard from "./StatisticCard";

export default StatisticCard;
